import { render } from "./PaperDetail.vue?vue&type=template&id=3578bd33&scoped=true"
import script from "./PaperDetail.vue?vue&type=script&lang=js"
export * from "./PaperDetail.vue?vue&type=script&lang=js"

import "./PaperDetail.vue?vue&type=style&index=0&id=3578bd33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3578bd33"]])

export default __exports__